module.exports = __webpack_public_path__ + "static/media/save46.19a5a1e9.png";